import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "0238avULtlEBY4Z4I9bs94f", "AdDob5", undefined);

//@ts-nocheck
import { E_ADUrl } from "../AdCtr";
import AdEvent from "../AdEvent";
import { E_ADEventType } from "../../EnumBase";
import { _decorator, log } from "cc";
var ccclass = _decorator.ccclass;

var AdDob5 = ccclass(_class = (_temp = /*#__PURE__*/function () {
  function AdDob5() {
    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "videoAdLoaded", false);

    _defineProperty(this, "_isCallPlay", false);

    _defineProperty(this, "isBannering", false);
  }

  var _proto = AdDob5.prototype;

  _proto.init = function init() {
    var _this = this;

    // this.addStatistics();
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = E_ADUrl.Dob5_Sdk;
    log("....api-game-191223....3333333.");

    script.onload = function () {
      log("....api-game-191223.....");
      var new_element = document.createElement('script');
      new_element.setAttribute('type', 'text/javascript');
      new_element.setAttribute('src', E_ADUrl.Dob5_Game);

      new_element.onload = function () {
        _this.videoAdLoaded = true;
        _this.interstitialAdLoaded = true;
      };

      new_element.onerror = function () {};

      document.body.appendChild(new_element);
    };

    script.onerror = function () {};

    head.appendChild(script);
  };

  _proto.playAD = function playAD() {
    var _this2 = this;

    if (this._isCallPlay) return;
    this._isCallPlay = true;
    console.log("...........playAD......");

    if (window['playDob5A']) {
      window['playDob5A'](function (state) {
        switch (state) {
          case 'start':
            console.log("start playDob5");
            break;

          case 'error':
            console.log("playDob5 fail");
            _this2._isCallPlay = false;
            AdEvent.I.handleEvent(E_ADEventType.video_showFail);
            break;

          case 'complete':
          case 'close':
            console.log("playDob5 close");
            _this2._isCallPlay = false;
            AdEvent.I.handleEvent(E_ADEventType.video_showOver);
            break;

          default:
            break;
        }
      });
    }
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {};

  _proto.showBannerAd = function showBannerAd() {};

  _proto.hideBannerAd = function hideBannerAd() {} // 创建插屏广告 展示一次调用一次创建
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   interstitialAdId: string 插屏广告ID 需后台申请
  //   style: int 广告类型 1 全屏 2 半屏
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {};

  _proto.showInterstitialAd = function showInterstitialAd() {
    if (this.interstitialAdLoaded) {
      this.playAD();
    } else {
      console.log("this._interstitialAd 广告未加载成功");
    }
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {};

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    if (this.videoAdLoaded) {
      this.playAD();
      console.log("rewardedvideoAd 视频广展示");
    } else {
      console.log("rewardedvideoAd 视频广告未加载成功");
    }
  }
  /**
  * 加入统计 dob5等平台使用
  */
  ;

  _proto.addStatistics = function addStatistics() {
    var head = document.getElementsByTagName('body')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = E_ADUrl.Dob5_Statistics;

    script.onload = function () {
      log("............statistics.onLoad......");
    };

    head.appendChild(script);

    if (!window["dataLayer"]) {
      window["dataLayer"] = [];
    }

    window["gtag"] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      window["dataLayer"].push(args);
    };

    window['gtag']("js", new Date());
    window['gtag']("config", "UA-155756551-1");
  };

  return AdDob5;
}(), _temp)) || _class;

export { AdDob5 as default };

_cclegacy._RF.pop();